import { P as PubSub } from './pubsub-CoPYzvVm.js';
import './notyf-DIw0RvBj.js';

class ProductPrice extends HTMLElement {
  #unsubscribeVariantChange;

  connectedCallback() {
    this.#unsubscribeVariantChange = PubSub.subscribe(
      'variant:change',
      ({ id, data: { html } }) => {
        id === this.dataset.productId && this.#handlePriceChange(html);
      }
    );
  }

  disconnectedCallback() {
    this.#unsubscribeVariantChange();
  }

  /**
   * Handle price change.
   * @param {HTMLElement} html - The HTML to render.
   */
  #handlePriceChange(html) {
    const productPrice = html.querySelector('product-price');
    this.innerHTML = productPrice.innerHTML;
  }
}

customElements.define('product-price', ProductPrice);
